// Featurebase SDK 초기화
!(function (e, t) {
  const a = "featurebase-sdk";
  function n() {
    if (!t.getElementById(a)) {
      var e = t.createElement("script");
      (e.id = a),
      (e.src = "https://do.featurebase.app/js/sdk.js"),
      t.getElementsByTagName("script")[0].parentNode.insertBefore(
        e,
        t.getElementsByTagName("script")[0]
      );
    }
  }
  "function" != typeof e.Featurebase &&
    (e.Featurebase = function () {
      (e.Featurebase.q = e.Featurebase.q || []).push(arguments);
    }),
  "complete" === t.readyState || "interactive" === t.readyState
    ? n()
    : t.addEventListener("DOMContentLoaded", n);
})(window, document);

// 사용자 식별 함수
export function identifyUser(userData) {
  Featurebase(
    "identify",
    {
      organization: "DOST11",
      email: userData.email,
      name: userData.name,
      // userId: userData.id,
      userHash: userData.userHash,
      // profilePicture: userData.profilePicture,
      // customFields: userData.customFields,
      // companies: userData.companies,
    },
    (err) => {
      if (err) {
        console.error("Featurebase identification error:", err)
      }
    }
  )
}

export function initFeedWidget() {
  Featurebase("initialize_feedback_widget", {
    organization: "DOST11",
    theme: "light", // required
    // placement: "right", // optional - remove to hide the floating button
    // email: "youruser@example.com", // optional
    // defaultBoard: "yourboardname", // optional - preselect a board
    locale: "ko", // Change the language, view all available languages from https://help.featurebase.app/en/articles/8879098-using-featurebase-in-my-language
    metadata: null // Attach session-specific metadata to feedback. Refer to the advanced section for the details: https://help.featurebase.app/en/articles/3774671-advanced#7k8iriyap66
  })
}

// DOM이 로드될 때 현재 사용자 데이터로 Featurebase 초기화
document.addEventListener('DOMContentLoaded', () => {
  const userDataElement = document.getElementById('featurebase-user-data')

  if (!userDataElement) { return }

  try {
    const userData = JSON.parse(userDataElement.getAttribute('data-user'))
    if (!userData) { return }

    identifyUser(userData)
  } catch (error) {
    console.error('Failed to parse user data for Featurebase:', error)
  }
})

document.addEventListener('DOMContentLoaded', () => {
  initFeedWidget()
})
